import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {WebCamModule} from 'ack-angular-webcam';

import {ProofOnWebPage} from './proof-on-web';
import {PipesModule} from '../../pipes/pipes.module';
import {ViewerDirective, ViewerContentDirective} from '../../directives/ng-viewer/viewer.directive';

@NgModule({
  declarations: [
    ProofOnWebPage,
    ViewerContentDirective,
    ViewerDirective,
  ],
  imports: [
    IonicPageModule.forChild(ProofOnWebPage),
    WebCamModule,
    PipesModule,
  ],
  exports: [
    ProofOnWebPage
  ]
})
export class ProofOnWebPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/proof-on-web/proof-on-web.module.ts